import { i18n } from 'fishx';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import { renderField, getFormErrorI18n, DefaultJudeOpt } from '@/utils';

export const getExchangeOfferFormItems = ({ exchangeOfferList, validPeriodList, isCasual, isPromotion }) => ([
  {
    label: i18n('BSNL_CASUAL_PLAN_CHANGE_PLAN'),
    name: 'BSNL_CASUAL_PLAN_CHANGE_PLAN', // 临时套餐可切换套餐
    options: {
      initialValue: isEmpty(exchangeOfferList) && exchangeOfferList[0],
      rules: [{ required: isPromotion, message: getFormErrorI18n(i18n('SELECT_OFFER_PLAN')) }],
    },
    type: 'offerSelectModal',
    formItemCompProps: {
      dataGroup: exchangeOfferList,
    },
  },
  {
    label: i18n('BSNL_CASUAL_PLAN_EXP_OFF'),
    name: 'BSNL_CASUAL_PLAN_EXP_OFF', // 临时套餐有效期
    options: { rules: [{ required: isCasual }], initialValue: (validPeriodList[0] || {}).value },
    type: 'select',
    data: validPeriodList,
    renderField: renderField.renderFieldForAttr,
  },
]);

export const needQueryAttrs = ['EXP_NEED_CHANGE_ACCESS_TYPE', 'BSNL_CASUAL_PLAN_EXP_OFF', 'EXP_ISDN_LAST_MILE_TYPE'];

// 其中客户订单属性，需要通过
//    a）新装与加装RESTful接口的【custOrder.attrValueList】映射到CRM的dubbo接口【NewConnection】和【AddServices】的【CustOrderAttrDtoList】。
//    b）移机接口【/drm/ding/subsService/subsShiftingBsnl】的【custOrderAttrDtoList】映射到CRM的dubbo接口【SubsShifting】的【CustOrderAttrDtoList】。
//    c）属性说明：
// NO BSNL_ORDER_PRIORITY ，所有场景下，需要通过查询客户详情之后，根据客户属性【BSNL_CUSTOMER_CLASSIFICATION】的取值，自动映射。BSNL_CUSTOMER_CLASSIFICATION=2（Normal）时，BSNL_ORDER_PRIORITY=Standard，其他均为High。
// NO BSNL_INFORMATION_CHANNEL ，开户场景下，BSNL_INFORMATION_CHANNEL取值固定传2，意为信息来自Point Of Sale。
// NO BSNL_NEED_CHECK_FEASIBILITY ，开户和移机场景下，BSNL_NEED_CHECK_FEASIBILITY取值固定传，意为都需要工勘。（代理商无法准确识别是否需要工勘）
// NO BSNL_SALES_CHANNEL ，开户场景下，BSNL_SALES_CHANNEL取值固定传4，意为销售渠道为代理商。
//    BSNL_ORDER_NOTES ，开户场景下，新增备注采集字段在订单末尾。手工输入，校验规则：255字符长度限制。
//    BSNL_SHIFT_ADDR_TYPE ，移机场景下，移机类型有单独字段采集，暂不传客户订单属性。
//    EXP_NEED_CHANGE_ACCESS_TYPE ，移机场景下，当页面选择移机类型为2时（ShiftType=2时），页面新增是否切换接入技术的选择（是与否，Y/N）。数据来源使用查询属性信息接口【drm/ding/custService/qryAttrInfoBsnl】，取【attrValueDtoList】（布尔值也可页面写死）。
//    BSNL_UPDATE_BILLING_ADDRESS 和 BSNL_SHIFT_BILLING_ADDRESS ，移机场景下，页面新增是否更换账单寄送地址选择（ BSNL_UPDATE_BILLING_ADDRESS ，是与否，Y/N）。数据来源使用查询属性信息接口【drm/ding/custService/qryAttrInfoBsnl】，取【attrValueDtoList】（布尔值也可页面写死）。当BSNL_UPDATE_BILLING_ADDRESS=Y时， 采集移机账单寄送地址 BSNL_SHIFT_BILLING_ADDRESS，手工输入，校验规则：255字符长度限制。
// 不需要前端采集 ------
// 客户订单属性：【custOrderAttrDtoList】
// BSNL_SALES_CHANNEL=4
// BSNL_ORDER_PRIORITY=Standard
// BSNL_INFORMATION_CHANNEL=2
// BSNL_NEED_CHECK_FEASIBILITY=Y
// 不需要前端采集 ------------

export const custOrderAttrFormItems = params => {
  const { modelKey, isTransferShift, isNewAcctAddr, transferAddress, custAddrList, defaultInfo, needChangeAddress, onNeedAddressChange } = params;

  const isNewConnection = (modelKey === 'newConnection');
  const isShift = (modelKey === 'shift');

  if (isNewConnection) {
    return [
      {
        label: i18n('BSNL_ORDER_NOTES'),
        name: 'BSNL_ORDER_NOTES', // 开户场景下，新增备注采集字段在订单末尾。手工输入，校验规则：255字符长度限制。
        type: 'input',
        options: {
          initialValue: (defaultInfo.find(it => it.attrCode === 'BSNL_ORDER_NOTES') || {}).attrValue,
          rules: [{ required: true, max: 225 }],
        },
        formItemCompProps: {},
      },
    ];
  }
  const shiftItems = [
    //   BSNL_UPDATE_BILLING_ADDRESS 和 BSNL_SHIFT_BILLING_ADDRESS ，
    // BSNL_UPDATE_BILLING_ADDRESS 移机场景下，页面新增是否更换账单寄送地址选择（ BSNL_UPDATE_BILLING_ADDRESS ，是与否，Y/N）。
    // 数据来源使用查询属性信息接口【drm/ding/custService/qryAttrInfoBsnl】，取【attrValueDtoList】（布尔值也可页面写死）。
    // 当 BSNL_UPDATE_BILLING_ADDRESS =Y时， 采集移机账单寄送地址 BSNL_SHIFT_BILLING_ADDRESS ，手工输入，校验规则：255字符长度限制。
    {
      label: i18n('BSNL_UPDATE_BILLING_ADDRESS'),
      name: 'BSNL_UPDATE_BILLING_ADDRESS',
      type: 'select',
      options: { rules: [{ required: true }], initialValue: isNewAcctAddr ? 'Y' : 'N' },
      data: DefaultJudeOpt,
      renderField: renderField.renderFieldNormal,
      formItemCompProps: {
        disabled: isNewAcctAddr,
        onChange: onNeedAddressChange,
      },
    },
    {
      label: i18n('BSNL_SHIFT_BILLING_ADDRESS'),
      name: 'BSNL_SHIFT_BILLING_ADDRESS',
      type: 'select',
      data: custAddrList,
      renderField: {
        valueField: 'custAddressId',
        lableField: 'labelValue',
      },
      options: {
        rules: [{ required: needChangeAddress }],
        initialValue: isNewAcctAddr && get(transferAddress, 'selectAddress'),
      },
      formItemCompProps: {
        disabled: !isNewAcctAddr && !needChangeAddress,
      },
    },
  ];
  if (isShift || isTransferShift) { // 移机、过户带移机
    return shiftItems;
  }
  return [];
};

// a）订户属性：
// BSNL_CASUAL_PLAN_CHANGE_PLAN ：促销套餐默认到期切换套餐标识，接口采集。 这个在临时套餐里采集，参考 getExchangeOfferFormItems
// BSNL_CASUAL_PLAN_EXP_OFF ：临时套餐期限，属性值表attr_value采集。这个在临时套餐里采集，参考 getExchangeOfferFormItems
// BSNL_PACKAGE_ID ：宽带带宽，当前选择套餐归属的 SERV_TYPE =79时，需要下拉框，数据来源使用 宽带套餐带宽查询接口【】。
// BSNL_VIRTUAL_VOICE_GSM_NBR ：转接号码PSTN，手工输入，校验规则：255字符长度限制
// BSNL_CUG_GROUP_NAME ：CUG群组名称，暂不采集，DSCM不存在创建群组的功能。
// EXP_ISDN_LAST_MILE_TYPE ：最后一公里接入方式，属性值表attr_value采集。
// EXP_DID_CNT ：分机号数量，详见下文。
// EXP_ISDN_E1_CNT ：开通的E1数量，详见下文。
// EXP_ISDN_INCOMMING_CHANNEL ：最大呼入通道数，详见下文。
// EXP_ISDN_OUTGOING_CHANNEL :最大呼出通道数，详见下文。

// 不需要前端采集 ------
// 订户订单属性：【custOrder.orderItemList.attrValueList】（SubsAttrDtoList）
// BSNL_SALES_CHANNEL=4
// 不需要前端采集 ------

export const subsAttrs = params => {
  const {
    modelKey,
    attrObj = {}, accessType, serviceType, packageIdList,
    isdnMaxE1Cnt, isdnMaxDidCnt,
    onISDNClick,
    getMax } = params;

  const getAttrGroup = key => get(attrObj, `${key}.valueList`) || [];

  let baseItem = [];
  if (accessType === 'VIRTUALL' && serviceType === '26') {
    baseItem = [
      ...baseItem,
      { // 当前选择套餐接入方式EXP_ACCESS_TYPE = Virtual AND SERV_TYPE=26 时，必须采集转接号码PSTN，手工输入，校验规则：255字符长度限制。
        label: i18n('BSNL_VIRTUAL_VOICE_GSM_NBR'),
        name: 'BSNL_VIRTUAL_VOICE_GSM_NBR',
        type: 'input',
        options: { rules: [{ required: true, max: 255 }], initialValue: '' },
        formItemCompProps: {},
      },
    ];
  }
  if (serviceType === '79') {
    baseItem = [
      ...baseItem,
      {
        label: i18n('BSNL_PACKAGE_ID'),
        name: 'BSNL_PACKAGE_ID',
        type: 'select',
        options: {
          rules: [{ required: true }],
          initialValue: ((getAttrGroup('BSNL_PACKAGE_ID')[0]) || {}).value,
        },
        data: packageIdList,
        renderField: {
          valueField: 'packageIdValue',
          lableField: 'packageIdValueMark',
        },
        formItemCompProps: {},
      },
    ];
  }
  if (serviceType === '83') {
    baseItem = [{
      label: i18n('EXP_ISDN_LAST_MILE_TYPE'),
      name: 'EXP_ISDN_LAST_MILE_TYPE',
      type: 'select',
      options: {
        rules: [{ required: true }],
        initialValue: ((getAttrGroup('EXP_ISDN_LAST_MILE_TYPE')[0]) || {}).value,
      },
      data: getAttrGroup('EXP_ISDN_LAST_MILE_TYPE'),
      renderField: renderField.renderFieldForAttr,
      formItemCompProps: {},
    }, ...baseItem];
    if (accessType === 'PRI' || accessType === 'BRI') {
      baseItem = [
        ...baseItem,
        {
          // 当EXP_ACCESS_TYPE = BRI 时，输入框中值不能大于8，且可以配置它的最大值；
          // 当EXP_ACCESS_TYPE = PRI 时，输入框中值不能大于6000，且最大值受属性 ISDN_MAX_DID_CNT 限制。
          label: i18n('EXP_DID_CNT'),
          name: 'EXP_DID_CNT',
          type: 'inputNumber',
          options: { rules: [{ required: true }], initialValue: 0 },
          formItemCompProps: {
            max: (accessType === 'BRI' && 8) || (accessType === 'PRI' && isdnMaxDidCnt),
          },
        },
        // 当EXP_ACCESS_TYPE = BRI 时，
        // 0 <= EXP_ISDN_INCOMMING_CHANNEL + EXP_ISDN_OUTGOING_CHANNEL <=2；
        // 当EXP_ACCESS_TYPE = PRI 时，
        // 0 <= EXP_ISDN_INCOMMING_CHANNEL + EXP_ISDN_OUTGOING_CHANNEL <=EXP_ISDN_E1_CNT值*30；
        {
          label: i18n('EXP_ISDN_INCOMMING_CHANNEL'),
          name: 'EXP_ISDN_INCOMMING_CHANNEL',
          type: 'inputNumber',
          options: {
            rules: [
              { required: true },
              {
                validator: (rule, value, callback) => getMax(rule, value, callback, 'EXP_ISDN_OUTGOING_CHANNEL'),
              },
            ],
            initialValue: 0,
          },
          formItemCompProps: {
            min: 0,
          },
        },
        {
          label: i18n('EXP_ISDN_OUTGOING_CHANNEL'),
          name: 'EXP_ISDN_OUTGOING_CHANNEL',
          type: 'inputNumber',
          options: {
            rules: [
              { required: true },
              {
                validator: (rule, value, callback) => getMax(rule, value, callback, 'EXP_ISDN_INCOMMING_CHANNEL'),
              },
            ],
            initialValue: 0,
          },
          formItemCompProps: {
            min: 0,
          },
        },
      ];
      if (accessType === 'PRI') {
        return [
          {
            // 当EXP_ACCESS_TYPE = BRI 时，本输入框隐藏.(因为BRI接入方式不需要E1依赖产品) ；
            // 当EXP_ACCESS_TYPE = PRI 时，输入框可编辑，且值需要大于等于1，且最大值受属性 EXP_ISDN_MAX_E1_CNT 限制。
            label: i18n('EXP_ISDN_E1_CNT'),
            name: 'EXP_ISDN_E1_CNT',
            type: 'inputNumber',
            options: { rules: [{ required: true }], initialValue: 1 },
            formItemCompProps: {
              min: 1,
              max: isdnMaxE1Cnt,
            },
          },
          ...baseItem,
        ];
      }
      return baseItem;
    }
  }
  if (modelKey === 'newConnection' && accessType === 'EPABX') {
    return [
      {
        label: i18n('BSNL_ISDN_MAIN_NUM'),
        name: 'BSNL_ISDN_MAIN_NUM',
        type: 'input',
        options: {
          rules: [{ required: true }],
        },
        formItemCompProps: {
          onClick: onISDNClick,
        },
      },
      ...baseItem,
    ];
  }
  return baseItem;
};

export const isdnSearchFormItems = [
  {
    label: i18n('MAIN_NUMBER'),
    name: 'isdnMainNbr', // 开户场景下，新增备注采集字段在订单末尾。手工输入，校验规则：255字符长度限制。
    type: 'input',
    options: {
      rules: [{ required: true }],
    },
    formItemCompProps: {},
  },
];
